document.addEventListener('DOMContentLoaded', () => {
    // slick default setting
    let defaulsettings = {
        loop: true,
        speed: 700,
        effect: 'fade',
        fadeEffect: {
            crossFade: true
        },
        navigation: {
            nextEl: '.swiper-prev',
            prevEl: '.swiper-next'
        },
        autoplay: {
            delay: 5000,
            disableOnInteraction: false
        }
    };

    // start slider default
    let allSwipper =[];

    document.querySelectorAll('.swiper-slider').forEach((element,i) => {

        let swiperConfig = element.dataset.swiper ? JSON.parse(element.dataset.swiper) : defaulsettings;
        element.setAttribute(`data-swiper-${i}`,"");
        let swiper = new Swiper(`[data-swiper-${i}]`, swiperConfig);
        allSwipper[i] = swiper;

    });
    //slider 2 images
    //slider 2 images
    let slider2Images = new Swiper('.swiper-img-slider', {
        loop: true,
        speed: 700,
        spaceBetween:10,
        slidesPerView:"auto",
        allowTouchMove: true,
        centeredSlides: true,
        navigation: {
            nextEl: ".slider-block_arrows .arrow-next",
            prevEl: ".slider-block_arrows .arrow-prev",
        },
        breakpoints: {
            600: {
                spaceBetween: 30,
                centeredSlides: false,
                allowTouchMove: false,
            },
        }
    });
    let slider2Copy = new Swiper('.swiper-copy-slider', {
        loop: true,
        speed: 700,
        slidesPerView:1,
        effect: 'fade',
        allowTouchMove: false,
        autoHeight: true,
        fadeEffect: {
            crossFade: true
        },
        navigation: {
            nextEl: ".slider-block_arrows .arrow-next",
            prevEl: ".slider-block_arrows .arrow-prev",
        },
        breakpoints: {
        600: {
            autoHeight: false,
        },
        }
       
    });

    if(slider2Images && windowWidth < 600){
        
        slider2Images.on('slideChange', function () {
            let moveTo = this.realIndex;
            if(this.el.parentElement.parentElement.parentElement.classList.contains('layout-1')) {
                //
            } else {
                moveTo = this.realIndex + 1;
                if(moveTo >= this.slidesGrid.length){
                    moveTo = 0;
                }    
            }
            
            slider2Copy.slideTo(moveTo);
            slider2Copy.update();
        });
    }
    

    if(document.querySelectorAll('.js-swiper-arrow').length > 0){
        let indexPagination = 0;
        document.querySelectorAll('.js-swiper-arrow').forEach((arrow) => {
            arrow.addEventListener('click', () => {
                
                let arrowLimit = parseInt(arrow.getAttribute('data-limit'));
                if(arrow.classList.contains('prev')) {
                    indexPagination = indexPagination == 0 ? arrowLimit : indexPagination - 1;
                } else {
                    indexPagination = indexPagination == arrowLimit ? 0 : indexPagination + 1;

                }
                let prevItem = indexPagination == 0 ? arrowLimit : indexPagination - 1;
                let nextItem = indexPagination == arrowLimit ? 0 : indexPagination + 1;
                document.querySelectorAll('.js-arrow-pagination').forEach((pagination,i) => {pagination.classList.add('hidden');});
                document.querySelectorAll('.js-arrow-pagination')[prevItem].classList.remove('hidden');
                document.querySelectorAll('.js-arrow-pagination')[nextItem].classList.remove('hidden');
                
            })
        })
    }

    let sliderGallery = new Swiper('.swiper-gallery', {
        loop: true,
        speed: 700,
        slidesPerView:'auto',
        centeredSlides:false,
        spaceBetween:20,
        navigation: {
            nextEl: ".gallery-block .arrow-next",
            prevEl: ".gallery-block .arrow-prev",
        },
        breakpoints: {

            768: {
                centeredSlides:true,
                spaceBetween:0,
            },
        }
    });
    let sliderFooter = new Swiper('.footer-swiper', {
        loop: true,
        speed: 700,
        slidesPerView:1,
        spaceBetween:0,
        autoplay: {
            delay: 4000,
            disableOnInteraction: false
        },
        navigation: {
            nextEl: ".footer-logos_arrows .arrow-next",
            prevEl: ".footer-logos_arrows .arrow-prev",
        },
        breakpoints: {

            768: {
                slidesPerView:2,
                spaceBetween:10,
            },
            900: {
                slidesPerView:4,
                spaceBetween:30,
            },
            1300: {
                slidesPerView:6,
                spaceBetween:50,
            },
        }
    });
    
    //
    let sliderEvents = new Swiper('.events-swiper', {
        loop: true,
        speed: 700,
        slidesPerView:'auto',
        spaceBetween:0,
        navigation: {
            nextEl: ".featured-event .arrow-next",
            prevEl: ".featured-event .arrow-prev",
        },
         breakpoints: {
            768: {
                spaceBetween:0,
            },
        }
    });
    let sliderAwards = new Swiper('.awards-block_slider', {
        loop: true,
        speed: 700,
        slidesPerView:1,
        spaceBetween:30,
        centeredSlides:true,
        navigation: {
            nextEl: ".awards-block .arrow-next",
            prevEl: ".awards-block .arrow-prev",
        },
        breakpoints: {
            1024: {
                slidesPerView: 3,
                spaceBetween:100,
            },
            768: {
                slidesPerView: 2,
                spaceBetween:80,
            },
        },
    });

    let slideExperiences = new Swiper('.experiences-block_slider', {
        loop: true,
        speed: 700,
        slidesPerView:1,
        spaceBetween:0,
        navigation: {
            nextEl: ".experiences-block .arrow-next",
            prevEl: ".experiences-block .arrow-prev",
        },
        breakpoints: {
            768: {
                slidesPerView: 4,
                spaceBetween:20,
            },
        },
    });
    if(document.querySelector('.experiences-block')){
        document.querySelectorAll('.experiences-block button').forEach(arrow => {
            arrow.addEventListener('click', () => {
                document.querySelectorAll('.experiences-block .item').forEach(item => {
                    item.classList.remove('active');
                    item.classList.remove('small')
                });
            })
        });
    }
    //cards mobile swiper-cards
    let slideCards = new Swiper('.swiper-cards', {
        loop: true,
        speed: 700,
        slidesPerView:1,
        spaceBetween:0,
        navigation: {
            nextEl: ".cards-block_arrows .arrow-next",
            prevEl: ".cards-block_arrows .arrow-prev",
        },
        breakpoints: {
            768: {
                slidesPerView: "auto",
                spaceBetween:20,
            },
        },
    });
});